<template>
  <div
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder"
    @click.self="closeModal">
    <div class="spl-modal">
      <div class="spl-modal__label">
        Recover your Password
      </div>
      <div class="spl-modal__close" @click="closeModal" />

      <form-label>Email</form-label>
      <form-input
        v-model="email"
        :required="true"
        :validate-email="true" />

      <div class="row">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            @onClick="closeModal">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button :wide="true" @onClick="submitModal">
            Send
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import webApi from '@/webApi'
import constants from '@/constants'

export default {
  name: 'RecoverPasswordModal',
  data () {
    return {
      isVisible: false,
      email: ''
    }
  },
  mounted () {
    window.bus.$on('openRecoverPasswordModal', this.onOpenRecoverPasswordModal)
  },
  beforeDestroy () {
    window.bus.$off('openRecoverPasswordModal', this.onOpenRecoverPasswordModal)
  },
  methods: {
    onOpenRecoverPasswordModal () {
      this.isVisible = true
    },
    closeModal () {
      this.isVisible = false
    },
    submitModal () {
      if (this.email !== '') {
        webApi.account.send_Reset_Password_Mail(this.email)
          .then((response) => {
            this.$toast('An email with a link to reset your password has been sent to your mail address', constants.defaultToastOptions())
          }).catch((response) => {
            window.bus.$emit('openErrorModal', 'Please try again.')
          // this.$router.push('login');
          })
        this.closeModal()
      } else {
        window.bus.$emit('openWarningModal', 'Please enter your email address.')
      }
    }
  }
}
</script>

<style lang="scss">
</style>
